import { Controller } from "@hotwired/stimulus";

export class FormInputController extends Controller {
  static targets = ["input", "errorMessage", "inputLabel"];
  static values = {
    initialValidate: String | Number,
  };

  validate() {
    const lang = document.documentElement.lang;
    const fieldName = this.inputLabelTarget.dataset.name;
    const initialValidate = this.initialValidateValue;
    const value = this.inputTarget.value;
    const isEmpty = !value || value === "" || value == initialValidate;

    let errorMessage = "";

    if (isEmpty) {
      if (lang === "en") {
        errorMessage = `${fieldName} is required.`;
      } else if (lang === "es") {
        errorMessage = `${fieldName} es requerido.`;
      }

      this.errorMessageTarget.innerHTML = errorMessage;
    } else {
      this.errorMessageTarget.innerHTML = "";
    }
  }
}
